    <script>
    import communication_plan from "@/api/project_communication_plan.js";
    import CardUI from "@/components/UI/CardUI.vue";
    import Empty from "@/components/Common/Empty.vue";
    import 'vue2-datepicker/locale/ru';
    import InputUI from "@/components/UI/InputUI.vue";
    import ButtonUI from "@/components/UI/ButtonUI.vue";
    import TextAreaUI from "@/components/UI/TextAreaUI.vue";

    export default {
        name: "ProjectItemCommunicationPlanComponent",
        data() {
            return {
                plans: [],
                createDialogOpen: false,
                loading: false,
                editPlan: {
                    title: null,
                    id: null,
                    frequency: null,
                    audience: null,
                    required_info: null,
                    communication_and_format: null
                }
            }
        },


        computed: {
            project() {
                return this.$store.state.projects.currentProject;
            },
        },

        methods: {
            async load() {
                this.plans = (await communication_plan.all({ id: this.$store.state.projects.currentProject.id })).data;
            },
            async remove(plan) {
                if (confirm('Удалить запись?')) {
                    await communication_plan.delete({ id: plan.id, project_id: this.project.id })
                    await this.load();
                }
            },
            async save() {
                this.loading = true;
                if (!this.editPlan.id) {
                    await communication_plan.store({ ...this.editPlan, project_id: this.$store.state.projects.currentProject.id })
                } else {
                    await communication_plan.update({ ...this.editPlan, project_id: this.$store.state.projects.currentProject.id })
                }
                await this.load();
                this.loading = false;
                this.createDialogOpen = false;
                this.clearDialog();
            },

            clearDialog() {
                this.editPlan = {
                    title: null,
                    duration: null,
                    start_at: null,
                    results: null,
                    participants: null,
                    place: null,
                    agenda: null,
                    id: null,
                }
            }
        },

        mounted() {
            this.load();
        },

        components: {
            ButtonUI, InputUI, CardUI, Empty, TextAreaUI
        }
    }

</script>

<template>
    <div>


        <v-dialog @click:outside="clearDialog" style="top: 100px !important;" v-model="createDialogOpen"
            max-width="600">
            <CardUI :loading="false">
                <template slot="body">
                    <v-card-title v-if="!editPlan.id" class="headline">
                        Создание встречи
                    </v-card-title>
                    <v-card-title v-else class="headline">
                        Редактирование встречи
                    </v-card-title>
                    <div class="pa-4">

                        <h4 class="my-2">Название встречи</h4>
                        <InputUI v-model="editPlan.title" counter dense outlined placeholder="Встреча с заказчиком"
                            prepend-icon="mdi-text"></InputUI>

                        <h4 class="my-2">Переодичность</h4>
                        <InputUI v-model="editPlan.frequency" counter dense outlined
                            placeholder="Каждый понедельник в 9:30" prepend-icon="mdi-text"></InputUI>

                        <h4 class="my-2">Для кого</h4>
                        <InputUI v-model="editPlan.audience" counter dense outlined placeholder="Проектная команда"
                            prepend-icon="mdi-text"></InputUI>

                        <h4 class="my-2">Какая информация необходима</h4>
                        <TextAreaUI v-model="editPlan.required_info" counter dense outlined
                            placeholder="Отчет по контрольным точкам проекта" prepend-icon="mdi-text" :autofocus="true">
                        </TextAreaUI>

                        <h4 class="my-2">Способ коммуникаций и форма представления информации</h4>
                        <TextAreaUI v-model="editPlan.communication_and_format" counter dense outlined
                            placeholder="Личная встреча" prepend-icon="mdi-text" :autofocus="true"></TextAreaUI>

                        <ButtonUI v-if="!editPlan.id" @click="save"
                            :disabled="!(editPlan.title && editPlan.frequency && editPlan.audience && editPlan.required_info && editPlan.communication_and_format)">
                            Создать встречу
                        </ButtonUI>

                        <ButtonUI v-else @click="save" :loading="loading"
                            :disabled="!(editPlan.title && editPlan.frequency && editPlan.audience && editPlan.required_info && editPlan.communication_and_format)">
                            Сохранить
                        </ButtonUI>
                    </div>
                </template>
            </CardUI>
        </v-dialog>



        <v-sheet class="pa-4 mb-2" style="border-radius: 10px;">
            <h4 class="title">План коммуникаций
                <div style="cursor:pointer;" @click="createDialogOpen = true" class="float-right add-task">
                    <v-icon>mdi-plus</v-icon>
                </div>
            </h4>
        </v-sheet>

        <Empty class="w-100" title="Планов пока нет," description="но их можно создать" v-if="plans.length == 0" />

        <CardUI class="mt-4 pl-2 pt-1 pr-1" v-for="plan in plans" :key="plan.id">
            <template slot="body">
                <h3>{{ plan.title }}
                    <v-btn @click="remove(plan)" right style="float: right" small icon>
                        <v-icon color="red">
                            mdi-trash-can
                        </v-icon>
                    </v-btn>
                    <v-btn v-if="project.permissions.can_edit_info"
                        @click="editPlan = JSON.parse(JSON.stringify(plan)); createDialogOpen = true" right
                        style="float: right" small icon>
                        <v-icon>
                            mdi-pencil
                        </v-icon>
                    </v-btn>
                </h3>

                <div class="plan-field">
                    <p class="mb-0">
                        <v-icon color="primary" small>mdi-calendar-range-outline</v-icon>
                        {{ plan.frequency }}
                    </p>

                    <p class="mb-0">
                        <v-icon color="primary" small>mdi-account-multiple-outline</v-icon>
                        {{ plan.audience }}
                    </p>

                    <h5>Необходимая информация</h5>
                    <p>{{ plan.required_info }}</p>

                    <h5>Способ коммуникаций и форма представления информации</h5>
                    <p>{{ plan.communication_and_format }}</p>
                </div>

            </template>
        </CardUI>

    </div>

</template>

<style>
@media only screen and (min-width: 800px) {
    .v-dialog {
        margin-top: 100px;
    }
}

.plan-field h5 {
  font-size: 16px;
  line-height: 1.4;
  margin: 8px 0;
}

.plan-field p {
  font-size: 16px;
  line-height: 1.4;
  margin: 0 0 16px;
}

.plan-field p:last-child {
  margin-bottom: 10;
}
</style>
